import { RichContentRenderer } from '@/components/seo-content-renderer';
import { Typo } from '@/components/ui/typography';
import PolicyLayout from '@/components/web/layouts/policy-layout';
import { Head } from '@inertiajs/react';

interface Post {
  id: number;
  title: string;
  slug: string;
  content: any;
}

interface Props {
  post: Post;
  posts: Array<{
    id: number;
    title: string;
    slug: string;
  }>;
  pageTitle: string;
  breadcrumbs?: any[];
}

export default function PolicyPage({ post, posts, pageTitle, breadcrumbs }: Props) {
  return (
    <PolicyLayout posts={posts} currentSlug={post.slug} breadcrumbs={breadcrumbs}>
      <Head>
        <title>{pageTitle}</title>
        <meta name="description" content={`Chính sách và điều khoản: ${post.title}`} />
      </Head>

      <Typo variant="h2" className="mb-8 text-2xl font-bold uppercase md:text-3xl">
        {post.title}
      </Typo>

      <div className="policy-content">
        {post.content ? <RichContentRenderer editorSerializedState={post.content} className="prose prose-lg max-w-none" /> : null}
      </div>
    </PolicyLayout>
  );
}
